/* eslint-disable brace-style */
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  AbstractFormDialog,
  AbstractFormDialogData,
  AbstractDialogResultData,
} from '@next/core-lib/dialog';

import { Subscription } from 'rxjs';

import { Treatment, TreatmentSchema } from '../../models';

export interface TreatmentSchemaDialogData extends AbstractFormDialogData {
  treatmentSchema: TreatmentSchema;
  treatments: Treatment[];
}

export interface TreatmentSchemaDialogFormResult {
  id: string;
  name: string;
  description: string;
  treatmentIds: boolean[];
}

@Component({
  selector: 'app-treatment-schema-dialog',
  templateUrl: './treatment-schema-dialog.component.html',
  standalone: false,
})
export class TreatmentSchemaDialogComponent
  extends AbstractFormDialog<TreatmentSchema>
  implements OnInit, OnDestroy
{
  data = inject<TreatmentSchemaDialogData>(MAT_DIALOG_DATA);
  private readonly formBuilder = inject(FormBuilder);
  protected readonly mdDialogRef =
    inject<MatDialogRef<TreatmentSchemaDialogComponent, AbstractDialogResultData<TreatmentSchema>>>(
      MatDialogRef,
    );

  treatmentsFromArray = this.formBuilder.array(
    this.data.treatments.map(
      (treatment) => this.data.treatmentSchema.treatmentIds.indexOf(treatment.id) > -1,
    ),
    [Validators.required],
  );
  formGroup = this.formBuilder.group({
    name: [this.data.treatmentSchema.name, [Validators.required, Validators.maxLength(100)]],
    description: [this.data.treatmentSchema.description, [Validators.maxLength(400)]],
    treatmentIds: this.treatmentsFromArray,
  });
  showMinOneTreatmentError = false;

  private subscription = new Subscription();

  ngOnInit(): void {
    this.subscription.add(
      this.treatmentsFromArray.valueChanges.subscribe(() => {
        this.showMinOneTreatmentError = false;
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  submit($event: TreatmentSchemaDialogFormResult) {
    const treatmentIds = $event.treatmentIds
      .map((isChecked, index) => isChecked && this.data.treatments[index].id)
      .filter(Boolean);

    if (!treatmentIds.length) {
      this.showMinOneTreatmentError = true;
      return;
    }

    super.confirm({
      ...$event,
      id: this.data.treatmentSchema.id,
      treatmentIds,
    });
  }
}
